module.exports = "/_next/static/images/91115089d35140933f35901fa43c7d44-woman-with-sandwich@1x.jpg";